import React from 'react';

import { locale } from '@trqk/utils';

import { CurrentPlanAmounts, CurrentPlanWrapper } from '.';

interface CurrentFreeTrialPlanProps {
    planSettings: ChargebeePlanSettings;
    subscriptionSettings: ChargebeeSubscriptionSettings | null;
    width: number;
    usage: PaymentPlanUsage;
}

/**
 * Renders the current "free trial" plan amounts, which are non-adjustable.
 * @param props - see {@link CurrentFreeTrialPlanProps}
 */
export const CurrentFreeTrialPlan = ({
    planSettings,
    subscriptionSettings,
    width,
    usage,
}: CurrentFreeTrialPlanProps): JSX.Element => (
    <CurrentPlanWrapper
        planSettings={planSettings}
        subscriptionSettings={subscriptionSettings}
    >
        <div className="space-y-3" style={{ width }}>
            <CurrentPlanAmounts
                label={
                    locale.enUS.ACCOUNT.SECTIONS.PAYMENT_PLAN.SETTINGS
                        .QUARTERLY_ROYALTIES
                }
                type="QUARTERLY_ROYALTIES"
                usageDetail={usage.royalties}
            />
            <CurrentPlanAmounts
                label={
                    locale.enUS.ACCOUNT.SECTIONS.PAYMENT_PLAN.SETTINGS
                        .DETECTION_TRACKS
                }
                type="DETECTIONS"
                usageDetail={usage.detectionTracks}
            />
        </div>
    </CurrentPlanWrapper>
);
